import api from '../services/api';
export const AboutModel = { fetch: (language) => api.getAbout(language) };
